export default __webpack_public_path__ + "static/media/Trip-bro.df2e0ddd.svg";